import NdisClaimNewReviewContainer from "./NdisClaimReview.container";

export default NdisClaimNewReviewContainer;
